//function to reduce complexity of the validateInput function. Returns true if undefined or 0.
export const isUndefinedOrNull = (input: number): boolean =>
  input === undefined || input === 0

//function to reduce complexity of the validateInput function. Returns true if undefined or empty.
export const isUndefinedOrEmpty = (input: string): boolean =>
  input === undefined || input === ''
